import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { PharmAuthorizationComponent } from '../pharm-authorization/pharm-authorization.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('../dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'orders',
        loadChildren: () => import('../orders/orders.module').then((m) => m.OrdersModule),
      },
      {
        path: 'authorization/:enterpriseOrderId',
        component: PharmAuthorizationComponent,
        loadChildren: () =>
          import('../pharm-authorization/pharm-authorization.module').then((m) => m.PharmAuthorizationModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('../profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'account',
        loadChildren: () => import('../account/account.module').then((m) => m.AccountModule),
      },
      {
        path: 'contact',
        loadChildren: () => import('../contact-us/contact-us.module').then((m) => m.ContactUsModule),
      },
      {
        path: 'payments',
        loadChildren: () => import('../payments/payments.module').then((m) => m.PaymentsModule),
      },
      { path: '**', redirectTo: '' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
